import React, { useEffect, useState } from "react"
import { keyframes } from "@emotion/core"
import styled from "@emotion/styled"
import CloseButton from "../CloseButton/close-button"
import "./modal.scss"

const fadeIn = keyframes`
  from {
    visibility: hidden;
    opacity: 0;
  }

  to {
    visibility: visible;
    opacity: 1;
  }
`

const fadeOut = keyframes`
  from {
    visibility: visible;
    opacity: 1;
  }

  to {
    visibility: hidden;
    opacity: 0;
  }
`

const ModalWrapper = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  z-index: 999;
  justify-content: center;
  align-items: center;
  animation: ${props => (props.out ? fadeOut : fadeIn)} 0.3s linear forwards;
`

const Modal = ({ leadership_name, leadership_position, modal }) => {
  const [out, setOut] = useState(true)
  useEffect(() => {
    setOut(false)
    document.body.classList.toggle("no-scroll")
  }, [])

  const closeModal = () => {
    setOut(true)
    document.body.classList.toggle("no-scroll")
  }
  return (
    <ModalWrapper out={out}>
      <div className="modal-content">
        <picture>
          <source srcSet={modal.desktop.url} media="(min-width: 768px)" />
          <source srcSet={modal.tablet.url} media="(min-width: 376px)" />
          <img src={modal.mobile.url} alt="Leaderership" />
        </picture>
        <div>
          <CloseButton onClick={closeModal}></CloseButton>
          <h3>{leadership_name}</h3>
          <p className="position">{leadership_position}</p>
          <div
            className="bio"
            dangerouslySetInnerHTML={{ __html: modal.bio }}
          />
        </div>
      </div>
    </ModalWrapper>
  )
}

export default Modal
